export default __webpack_public_path__ + "static/media/failedpayment.740f7f7a.svg";